<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import BottomNav from '@/components/BottomNav.vue';
import AwardOverlay from '@/components/AwardOverlay.vue';
import TimerFab from '@/components/TimerFab.vue';
import OnboardingOverlay from '@/components/OnboardingOverlay.vue';
import VerifyEmailBanner from '@/components/VerifyEmailBanner.vue';
import { useAuthStore } from '@/stores/auth';
import { useAwardsStore } from '@/stores/awards';

const route = useRoute();
const auth = useAuthStore();
const awards = useAwardsStore();

const showNav = computed(() => auth.isAuthenticated && !route.meta.public);
</script>

<template>
  <v-app>
    <v-main>
      <!-- Soft email-verification nudge; self-gates on auth + unverified. -->
      <VerifyEmailBanner v-if="showNav" />
      <router-view />
    </v-main>
    <BottomNav v-if="showNav" />

    <!-- Global "active timer" shortcut. Visible on every page when a
         timer is running or paused; tap to jump straight to the event. -->
    <TimerFab v-if="showNav" />

    <!-- Global award celebration overlay — any store can enqueue
         awards and they play here, regardless of which view is mounted. -->
    <AwardOverlay :award="awards.current" @close="awards.dismissCurrent" />

    <!-- First-time onboarding flow. Self-gates on auth + weeklyStudyHours. -->
    <OnboardingOverlay />
  </v-app>
</template>
